import { service } from '../../../../helpers/http' 

export const ActionGetAdditionalServices = ({ dispatch }, payload) => { 
    return service({
        module: 'additionalService',
        action: 'getAdditionalServices',
        payload: payload
    })
}

export const ActionPostAdditionalServices = ({ dispatch }, payload) => {

    return service({
        module: 'additionalService',
        action: 'postAdditionalServices',
        payload: payload
    })
    
}

export const ActionPutAdditionalServices = ({ dispatch }, payload) => {

    return service({
        module: 'additionalService',
        action: 'putAdditionalServices',
        payload: payload
    })
    
}

export const ActionDeleteAdditionalServices = ({ dispatch }, payload) => {

    return service({
        module: 'additionalService',
        action: 'deleteAdditionalServices',
        payload: payload
    })
    
}
